import { Image } from "@chakra-ui/react"

function Icon(){
    return(
        <Image src="https://www.revv.co.in/assets/RentalImages/HomeScreen/locationRental.svg" />
    )
}

export {Icon}